import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';
import AdminBulkPreview from '../AdminBulkPreview.js';

const BulkResetPasswordModal = ({ isOpen, onClose, onConfirm, users, loading }) => (
  <AdminModal
    isOpen={isOpen && users?.length > 0}
    onClose={onClose}
    title="Reset Passwords"
    actions={(
      <>
        <button className="cancel-button" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Reset All Passwords'}
        </button>
      </>
    )}
  >
    <p>Are you sure you want to reset passwords for {users?.length} user{users?.length > 1 ? 's' : ''}?</p>
    <AdminBulkPreview
      items={users || []}
      getKey={(user) => user.userId}
      getName={(user) => user.name}
      getMeta={(user) => user.email}
      noun="user"
    />
    <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
      All selected users will receive instructions to set new passwords via email.
    </p>
  </AdminModal>
);

export default BulkResetPasswordModal;
